import { FC } from "react";
import Home from "./Home";
import { HomeSection } from "./HomeSection";
import Text from "@src/lib/ui/Text";
import { useUserContextState } from "@src/lib/contexts/UserContext";
import { getTimeOfDay } from "@src/lib/utils/dates";
import OverviewOfYourLocationsWidgets from "@src/features/home/OverviewOfYourLocationsWidgets";
import LocationAssignmentLeaderboardWidget from "./LocationAssignmentLeaderboardWidget";
import ActiveLanguagesWidget from "./ActiveLanguagesWidget";
import MyTrainingCarousel from "./MyTrainingCarousel";

const ManagerHome: FC = () => {
  const { user } = useUserContextState();

  return (
    <Home>
      <div className="flex flex-col gap-6">
        {user?.firstName && (
          <Text variant="display">
            Good {getTimeOfDay()}, {user.firstName}
          </Text>
        )}
        <MyTrainingCarousel />
        <OverviewOfYourLocationsWidgets />
        <HomeSection title="Usage">
          <div className="grid grid-cols-1 gap-4">
            <ActiveLanguagesWidget />
          </div>
        </HomeSection>
        <HomeSection title="Assignments">
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
            <LocationAssignmentLeaderboardWidget />
          </div>
        </HomeSection>
      </div>
    </Home>
  );
};

export default ManagerHome;
